const File = {
  featuredBanner: {
    maxUploadFileSize: 1024 * 1024 * 2,
    allowDimension: { width: 840, height: 1152 },
  },
  transactionDetail: {
    maxUploadFileSize: 1024 * 1024 * 20,
  },
  creditSummary: {
    maxUploadFileSize: 1024 * 1024 * 20,
  },
};
export default File;
